import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['trigger', 'section'];

  show() {
    this.triggerTarget.classList.add('clicked');
    this.sectionTarget.classList.add('opened');
  }
}
